import React, { useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { PetPolicyDetailsPanel } from '../../components/petPolicyDetails/petPolicyDetailsPanel/petPolicyDetailsPanel';
import { AddAPet } from '../../components/addAPet/addAPet';
import { useGetPetInfoQuery } from '../../data/policy';
import { SLICES } from '../../constants/slices';
import Loading from '../../components/shared/Loading/Loading';
import { scrollElementIntoView } from '../../utils/scrollUtils';
import { useGetFaqContentQuery } from '../../data/kontentAi';
import { BrandContext } from '../../contextProviders/brandContext';
import { FeatureFlagContext } from '../../contextProviders/featureFlagContext';
import { FAQ_CODENAME } from '../../constants/cmsCodeName';
import { FaqsBlock } from '../../components/helpCentre/faqsBlock/faqsBlock';
import './myPets.scss';

export const MyPets = () => {
  const { activeBrandContext } = useContext(BrandContext);
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;
  const { authDetails } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);
  const isRenewalHubEnabled = cspConfiguration?.IsRenewalHubEnabled || false;
  const { auth0AccessToken } = authDetails;
  const { data: petDetailsData, isLoading: petDetailsDataLoading } = useGetPetInfoQuery(auth0AccessToken, {
    skip: !auth0AccessToken
  });
  const { data: faqsData } = useGetFaqContentQuery(
    {
      brandPartner: activeBrandContext.brand.key,
      faqCodeName: FAQ_CODENAME.MY_PETS,
      previewEnabled: isKontentAiPreviewEnabled
    },
    { skip: !isRenewalHubEnabled }
  );
  const hasFaqData = faqsData && Object.keys(faqsData).length > 0;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const policyFromUrl = params.get('policy');

  const panelRefs = useRef({});

  const setPanelRef = (key) => (el) => {
    if (el) {
      panelRefs.current[key] = el;
      if (key === policyFromUrl) {
        requestAnimationFrame(() => {
          scrollElementIntoView(el);
        });
      }
    }
  };

  return (
    <main
      className="myPets"
      aria-label="My Pets page"
    >
      <h1 className="mainPageHeader">My pets</h1>
      <div className="main-content">
        {petDetailsDataLoading ? (
          <Loading />
        ) : (
          petDetailsData?.map((petDetail) => (
            <div
              key={petDetail.PolicyNumber}
              ref={setPanelRef(petDetail.PolicyNumber)}
            >
              <PetPolicyDetailsPanel
                key={petDetail.PolicyNumber}
                petDetail={petDetail}
              />
            </div>
          ))
        )}
      </div>

      {hasFaqData && isRenewalHubEnabled && (
        <aside>
          <FaqsBlock
            questionSet={faqsData?.FAQs?.questions}
            heading={{ text: 'FAQs' }}
          />
        </aside>
      )}
      <AddAPet />
    </main>
  );
};
